import React from 'react';

type Props = {
    src: string;
    alt?: string;
    title?: string;
    width?: number;
    height?: number;
    loading?: 'lazy' | 'eager';
};

const Image = (props: Props) => {
    const alt = props.alt ?? '';
    return (
        <img {...props} alt={alt}/>
    )
}

export default Image;